import React from 'react';
import classNames from 'classnames';

const buildPageItems = (currentPage, totalPages) => {
  if (totalPages <= 10) return Array.from({ length: totalPages }, (_, i) => i + 1);

  const pages = [];

  if (currentPage <= 6) {
    pages.push(...Array.from({ length: 7 }, (_, i) => i + 1));
    pages.push('ellipsis');
    pages.push(totalPages);
    return pages;
  }

  if (currentPage >= totalPages - 5) {
    pages.push(1);
    pages.push('ellipsis');
    pages.push(...Array.from({ length: 7 }, (_, i) => totalPages - 6 + i));
    return pages;
  }

  pages.push(1);
  pages.push('ellipsis');
  pages.push(currentPage - 2);
  pages.push(currentPage - 1);
  pages.push(currentPage);
  pages.push(currentPage + 1);
  pages.push(currentPage + 2);
  pages.push('ellipsis');
  pages.push(totalPages);
  return pages;
};

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const pageItems = buildPageItems(currentPage, totalPages);

  return (
    <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={classNames(
          'px-3 py-1 rounded-lg font-medium transition focus:outline-none focus:ring-2 focus:ring-purple-500',
          currentPage === 1
            ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
            : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
        )}
      >
        Prev
      </button>

      {pageItems.map((item, index) =>
        item === 'ellipsis' ? (
          <span key={`ellipsis-${index}`} className="px-3 py-1 text-gray-400">
            ...
          </span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => onPageChange(item)}
            className={classNames(
              'px-3 py-1 rounded-lg font-medium transition focus:outline-none focus:ring-2 focus:ring-purple-500',
              currentPage === item
                ? 'bg-purple-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            )}
          >
            {item}
          </button>
        )
      )}

      <button
        type="button"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={classNames(
          'px-3 py-1 rounded-lg font-medium transition focus:outline-none focus:ring-2 focus:ring-purple-500',
          currentPage === totalPages
            ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
            : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
        )}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
